var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-auto"},[_c('CLHeader',{attrs:{"mainTopic":"Label Processes","subTopic":"Today"}})],1)]),_c('div',{staticClass:"row mt-3 mb-0"},[_c('exporter-process-grid')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }